import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../../utils/reduxHelper";

export const creatorProductTryOnReduxAPI = createApi({
  reducerPath: "creatorProductTryOnReduxAPI",
  baseQuery: baseQueryWithArgs,
  tagTypes: ["CreatorProductTryOn"],
  endpoints: (builder) => ({
    getCreatorProductTryOns: builder.query({
      query: (productIds) =>
        getQueryStringWithCreator(
          `c/getCreatorProductTryOns?product_ids=${productIds.join(",")}`
        ),
      providesTags: ["CreatorProductTryOn"],
    }),
    getCreatorProductTryOnUploadUrls: builder.mutation({
      query: (body) => ({
        url: "c/getCreatorProductTryOnUploadUrls",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
    saveCreatorProductTryOn: builder.mutation({
      query: (body) => ({
        url: "c/saveCreatorProductTryOn",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: ["CreatorProductTryOn"],
    }),
  }),
});

export const {
  useGetCreatorProductTryOnsQuery,
  useGetCreatorProductTryOnUploadUrlsMutation,
  useSaveCreatorProductTryOnMutation,
} = creatorProductTryOnReduxAPI;
